<template>
  <div class="bg-[#F7F9F9]">
    <!-- コース紹介 -->
    <TeCourseIndexAbout />

    <!-- 人気のカテゴリを見る -->
    <TeCourseIndexRecommend />

    <!-- コース比較表 -->
    <!-- 表示削除1205 -->
    <!-- <TeCourseIndexComparison /> -->

    <!-- 締め切り -->
    <!-- 表示削除1205 -->
    <!-- <TeCourseIndexBootcampDeadline :cohort="cohort" /> -->

    <!-- コース紹介 - 副業向け -->
    <TeCourseIndexSidejob />

    <!-- 初心者向け -->
    <TeCourseIndexBeginner />

    <!-- フリーランス -->
    <TeCourseIndexFreelance />

    <!-- アプリ・ゲーム -->
    <TeCourseIndexAppgame />

    <!-- AI・機械学習・データ分析 -->
    <TeCourseIndexMachineLearning />

    <!-- Webマーケティング -->
    <TeCourseIndexWebMarketing />

    <!-- 複数コース受講でさらにお得 -->
    <TeCourseIndexSet />

    <!-- オススメコース診断 -->
    <!-- 表示削除1205 -->
    <!-- <TeCommonBannerDiagnoses /> -->

    <!-- 表示削除1205 -->
    <!-- <section
      id="training"
      class="px-4 pb-4 pt-6 text-left md:pb-4 md:pt-10 md:text-center"
    >
      <h2 class="co-display-9 mb-6 text-center font-bold">
        相談してコースを選びたい方は
      </h2>
      <div class="text-center">
        <TeCommonArrowDown class="mx-auto" />
      </div>
    </section> -->

    <!-- 現役エンジニアのテックアカデミーメンターに -->
    <!-- 表示削除1205 -->
    <!-- <TeCommonBannerBriefingHtmlcssTrial /> -->

    <!-- 下部固定ボタン -->
    <!-- 表示削除1205 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { getLatestCohort } from '~/utility/fetchAPI'

import TeCourseIndexAbout from '~/components/Te/TeCourse/Index/TeCourseIndexAbout.vue'
import TeCourseIndexRecommend from '~/components/Te/TeCourse/Index/TeCourseIndexRecommend.vue'
import TeCourseIndexComparison from '~/components/Te/TeCourse/Index/TeCourseIndexComparison.vue'
import TeCourseIndexBootcampDeadline from '~/components/Te/TeCourse/Index/TeCourseIndexBootcampDeadline.vue'
import TeCourseIndexSidejob from '~/components/Te/TeCourse/Index/TeCourseIndexSidejob.vue'
import TeCourseIndexBeginner from '~/components/Te/TeCourse/Index/TeCourseIndexBeginner.vue'
import TeCourseIndexFreelance from '~/components/Te/TeCourse/Index/TeCourseIndexFreelance.vue'
import TeCourseIndexAppgame from '~/components/Te/TeCourse/Index/TeCourseIndexAppgame.vue'
import TeCourseIndexMachineLearning from '~/components/Te/TeCourse/Index/TeCourseIndexMachineLearning.vue'
import TeCourseIndexWebMarketing from '~/components/Te/TeCourse/Index/TeCourseIndexWebMarketing.vue'
import TeCourseIndexSet from '~/components/Te/TeCourse/Index/TeCourseIndexSet.vue'
import TeCommonBannerDiagnoses from '~/components/Te/TeCommon/Banner/TeCommonBannerDiagnoses/TeCommonBannerDiagnoses.vue'
import TeCommonBannerBriefingHtmlcssTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerBriefingHtmlcssTrial/TeCommonBannerBriefingHtmlcssTrial.vue'
import TeCommonArrowDown from '~/components/Te/TeCommon/Arrow/TeCommonArrowDown/TeCommonArrowDown.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

const options = {
  async setup() {

    const { api } = useNuxtApp()

    return {
      api,
    }
  },
  oldHead() {
    const env = process.env.NODE_ENV || 'development'
    const scriptTags = scriptTagsByConfig({
      env: env as 'production' | 'development',
      useCase: 'course',
      deviceSize: useNuxtApp().$deviceSize,
    })
    return {
      title:
        'プログラミングスクール コース紹介｜目的別おすすめ｜テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【公式】オンラインプログラミングスクールのテックアカデミーコース一覧。未経験からエンジニア、デザイナーを目指すために何を勉強したらいいかをイメージしやすいようコースをご紹介。',
          twitterTitle: 'コース紹介｜TechAcademy [テックアカデミー]',
          twitterDescription:
            '何を勉強したらいいかをイメージしやすいようコースをご紹介',
          twitterImage: '/_nuxt/ogp/og-image-course.jpg',
          ogTitle: 'コース紹介｜TechAcademy [テックアカデミー]',
          ogDescription:
            '何を勉強したらいいかをイメージしやすいようコースをご紹介',
          ogUrl: '/course',
          ogImage: '/_nuxt/ogp/og-image-course.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohort: null,
    }
  },
  methods: {},
  mounted() {
    getLatestCohort(this.$api).then((response) => {
      this.cohort = response.data
    })
  },
  components: {
    TeCourseIndexAbout,
    TeCourseIndexRecommend,
    TeCourseIndexComparison,
    TeCourseIndexBootcampDeadline,
    TeCourseIndexSidejob,
    TeCourseIndexBeginner,
    TeCourseIndexFreelance,
    TeCourseIndexAppgame,
    TeCourseIndexMachineLearning,
    TeCourseIndexWebMarketing,
    TeCourseIndexSet,
    TeCommonBannerDiagnoses,
    TeCommonBannerBriefingHtmlcssTrial,
    TeCommonArrowDown,
    TeCommonButtonFixedBottom,
  },
}

export default defineNuxtComponent(options)
</script>
